<!-- <div style="display: flex; justify-content: space-between; margin: 5px;font-size:x-small;">
    <div>
        <div class="OverallGradeLabel">Game</div>
        <div [class]="this.classesRankingBox[this.GamePerformance]"></div>{{this.GamePerformanceText}}
    </div>
    <div>
            <div class="OverallGradeLabel">Capacity</div>
            <div [class]="this.classesRankingBoxCapacity[floor(this.Capacity)]"></div>{{this.CapacityText}}
    </div>
    <div>
            <div class="OverallGradeLabel">Projection</div>
            <div [class]="this.classesRankingBoxProjection[this.TotalQuality]"></div>{{this.TotalQualityText}}
    </div>
</div> -->

<div style="display: flex; flex-direction: column; justify-content: normal ;  margin: 5px;font-size:10px; flex-wrap: wrap; gap: 4px;">

    <div style="display: flex; flex-direction: row;">
        @if(this.GamePerformance!==0 && this.GamePerformance!=null){
            <div>
                <div class="OverallGradeLabel">{{'SCOUTING.GAME' | translate}}</div>
                <div [class]="this.classesRankingBox[this.GamePerformance]">{{this.GamePerformanceText}}</div>
            </div>
        }
        @if(this.PositionId!==0 && this.PositionId!=null){
            <div>
                <div class="OverallGradeLabel">{{'SCOUTING.POSITION' | translate}}</div>
                <div class="grayshading">{{this.PositionText}}</div>
            </div>
        }

    </div>
   
     <div style="display: flex; flex-direction: row;">
    @if(this.Capacity!==0 && this.Capacity!=null && this.Capacity!= undefined){
        <div>
            <div class="OverallGradeLabel">{{'SCOUTING.CAPACITY' | translate}}</div>
            <div [class]="this.classesRankingBoxCapacity[floor(this.Capacity)]">
                {{this.CapacityText}}
            </div>
        </div>
    }

    @if(this.PlayerType!==0 && this.PlayerType!=null){
        <div>
            <div class="OverallGradeLabel">{{'SCOUTING.PLAYER_TYPE' | translate}}</div>
            <div  class="grayshading">
                {{this.PlayerTypeText}}
            </div>
        </div>
    }
    </div>

    <div style="display: flex; flex-direction: row;">
        @if(this.CurrentLevelRanking!==0 && this.CurrentLevelRanking!=null){
            <div>
                    <div class="OverallGradeLabel" >{{'SCOUTING.CURRENT_LEVEL' | translate}}</div>
                    <div [class]="'outlined_' + this.classesRankingBoxProjection[floor(this.CurrentLevelRanking)]" >{{this.CurrentLevelRankingText}}</div>
            </div>
            
        }
        <div>
                <div class="OverallGradeLabel">{{'SCOUTING.PROJECTION' | translate}}</div>
                <div [class]="this.classesRankingBoxProjection[floor(this.TotalQuality)]">{{this.TotalQualityText}}</div>
        </div>
    </div>
</div>
